import firebase from "firebase/app";

export const unitCollectionKey = "units";
export const reflectionCollectionKey = "reflections";

export type Unit = {
  ref: firebase.firestore.DocumentReference;
  data: UnitData;
};

export type UnitData = {
  name: string;
  graphTitle: string;
  secondRowTitle: string;
  thirdRowTitle: string;
  createdAt: number;
  uid: string;
  selfReflection?: string;
  teacherReflection?: string;
  aiReflection?: string;
};

export function convertToUnit(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Unit {
  return {
    ref,
    data: {
      name: data.name,
      graphTitle: data.graphTitle ?? "",
      secondRowTitle: data.secondRowTitle ?? "",
      thirdRowTitle: data.thirdRowTitle ?? "",
      createdAt: data.createdAt,
      uid: data.uid,
      selfReflection: data.selfReflection ?? "",
      teacherReflection: data.teacherReflection ?? "",
      aiReflection: data.aiReflection ?? ""
    }
  };
}

export type Reflection = {
  ref: firebase.firestore.DocumentReference;
  data: ReflectionData;
};

export type ReflectionTimeRange = {
  start: number;
  end: number;
};

export type ReflectionData = {
  uid: string;
  record: number;
  reflection: string;
  description: string;
  createdAt: number;
  updatedAt: number;
  timeRange?: ReflectionTimeRange;
};

export function convertToReflection(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Reflection {
  const _data: ReflectionData = {
    uid: data.uid,
    record: data.record,
    reflection: data.reflection,
    description: data.description,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt
  };

  if (data.timeRange) {
    _data.timeRange = data.timeRange;
  }

  return {
    ref,
    data: _data
  };
}
